module.exports = "precision highp float;\n#define GLSLIFY 1\n\nuniform mat4 uModel;\nuniform mat4 uView;\nuniform mat4 uProjection;\n\nattribute vec3 position;\nattribute vec2 uv;\n\nvarying vec2 vUv;\n\nvoid main(){\n  vUv = uv;\n  gl_Position = uProjection * uView * uModel * vec4(position, 1.0);\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./~/glslify-loader!./src/shaders/chunk.vert
 ** module id = 768
 ** module chunks = 0
 **/